// extracted by mini-css-extract-plugin
export var brand = "_2y-9";
export var button = "_2y-0";
export var chevron = "_2y-v";
export var chevronButton = "_2y-w";
export var content = "_2y-n";
export var danger = "_2y-g";
export var dangerOutlined = "_2y-h";
export var dark = "_2y-l";
export var darkTheme = "_2y-c";
export var extraSmall = "_2y-4";
export var fullWidth = "_2y-8";
export var ghost = "_2y-d";
export var gray = "_2y-t";
export var icon = "_2y-p";
export var iconButton = "_2y-s";
export var iconButtonBorder = "_2y-x";
export var iconButtonBorderDark = "_2y-y";
export var iconButtonBorderLight = "_2y-z";
export var iconLeft = "_2y-q";
export var iconRight = "_2y-r";
export var large = "_2y-1";
export var light = "_2y-m";
export var medium = "_2y-2";
export var micro = "_2y-5";
export var nano = "_2y-7";
export var outlined = "_2y-k";
export var pending = "_2y-a";
export var primary = "_2y-i";
export var shadow = "_2y-o";
export var small = "_2y-3";
export var solidLight = "_2y-e";
export var solidLightBrand = "_2y-f";
export var spinner = "_2y-u";
export var transparent = "_2y-j";
export var warning = "_2y-b";
export var wideNano = "_2y-6";